(() => {
  if (window.barewayPdpStoryLoaded) return;
  window.barewayPdpStoryLoaded = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-bw-selection-link]');
    if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    const choices = [...target.querySelectorAll('.product-form__input select:not([disabled]), .product-form__input input:checked:not([disabled]), .product-form__input button:not([disabled])')];
    const choice = choices.find(item => item.getClientRects().length > 0);
    if (choice) choice.focus({ preventScroll: true });
    else {
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
      target.focus({ preventScroll: true });
    }
    const destination = choice?.closest('.product-form__input') || target;
    destination.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  });
})();
